import React from 'react'
import SoftDropdownButton from '@components/common/SoftDropDownButton'
import CurrencySelector from './CurrencySelector';
import { useIsDesktop } from '@components/helpers/useWindowSize';

const AnnouncementMenu = () => {
	const isDesktop = useIsDesktop()
	
	const menu = [
		// {
		// 	label: 'SHIPPING & ORDERS',
		// 	subMenus: [
		// 		{ label: 'Shipping Policy', url: 'https://black-bough-swim.reamaze.com/kb/shipping' },
		// 		{ label: 'Shipping Rates', url: 'https://blackboughswim.com/shipping-and-order-information' },
		// 	]
		// },
		{
			label: 'FIND YOUR FIT',
			subMenus: [
				{ label: 'General Size Guide', link: '/blackbough-size-guide' },
				{ label: 'Bikini Style Guide', link: '/bikini-style-guide' },
			],
		},
		{
			label: 'RETURNS & EXCHANGES',
			subMenus: [
				// { label: 'Request a Return', url: 'https://blackboughswim.loopreturns.com/' },
				{ label: 'Request a Return', link: '/return-a-product/' },
				{ label: 'Return Policy', url: 'https://black-bough-swim.reamaze.com/kb/returns' },
			]
		},
		{
			label: 'NEED HELP?',
			subMenus: [
				{ label: 'FAQ', url: 'https://black-bough-swim.reamaze.com/' },
                { label: 'USA Tariffs Guide', link: '/tariffs/' },
				{ label: 'Contact Us', link: '/contact-us' },
			]
		},
	]
  
	return (
		<React.Fragment>
			<section className="ml-auto hidden md:block lg:mr-4">
				<div className="flex gap-x-5 items-center">
                    { (process.env.GATSBY_STORE !== "PH" && isDesktop) && <CurrencySelector /> }

					<SoftDropdownButton 
						label="Customer Care" 
						iconGap='gap-x-2'
						menu={menu}
						openOnHover
						openChildOnHover
					/>

					<a href='https://black-bough-swim.reamaze.com/' target='_blank' className='soft-button w-fit text-white' aria-label='FAQs'>FAQ</a>
				</div>
			</section>
		</React.Fragment>
	);
};

export default AnnouncementMenu